/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, Divider, FormControl, Grid, IconButton, InputLabel, OutlinedInput, Paper, styled, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { defaultApiCall, updateUser } from '../../../redux/Actions/userActions';
import { showNotification } from '../../../common/Notification/ToastifyNotification';
import { createAddress, defaultOrgApiCall, getAddress, getOrganization, updateAddress } from '../../../redux/Actions/orgAction';
import { LoadingPage } from '../../../common/LoadingPage';
import { countries } from '../../../common/const';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { orgUpdate } from '../../../redux/Reducers/orgReducers';
import { apiRequest } from '../../../common/common';
import { ClearIcon } from '@mui/x-date-pickers';

const DividerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    minHeight: 50
}));

const DemoPaper = styled(Paper)(({ theme }) => ({
    marginTop: 10,
    padding: 10,
}));

const Heading = styled(Typography)(({ theme }) => ({
    borderBottom: '3px solid lightgray',
    width: 148
}));

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


export default function MyProfile() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, user, error, message, roles } = useSelector(state => state.users);
    const { orgLoading, organization, orgError, orgMessage, address } = useSelector(state => state.organizations);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [phone, setPhone] = useState(null);
    const [orgPhone, setOrgPhone] = useState(null)
    const [email, setEmail] = useState(null);
    const [orgWebsite, setOrgWebsite] = useState(null);
    const [department, setDepartment] = useState(null);
    const [title, setTitle] = useState(null);
    const [country, setCountry] = useState(null);
    const [address1, setAddress1] = useState(null);
    const [address2, setAddress2] = useState(null);
    const [city, setCity] = useState(null);
    const [state, setState] = useState(null);
    const [zipCode, setZipCode] = useState(null);
    const [errors, setErrors] = useState({});
    const [logos, setLogos] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);


    useEffect(() => {
        if (address?.address_id) {
            setCountry(address?.country);
            setState(address?.state);
            setZipCode(address?.pincode);
            setCity(address?.city);
            setAddress1(address?.address_line_1);
            setAddress2(address?.address_line_2);
        }
    }, [address]);

    useEffect(() => {
        if (organization?.org_name) {
            setEmail(organization?.org_email || user?.email);
            setOrgPhone(organization?.org_phone_number || user?.phone_number);
            setOrgWebsite(organization?.org_website);
            setDepartment(organization?.department);
            setTitle(organization?.title);
        }
    }, [organization]);

    const handleAccountUpdate = () => {
        const newErrors = {};
        if (!firstName) {
            newErrors.firstName = 'First Name is required';
        }
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            const data = {
                userId: user?.user_id,
                firstName: firstName,
                email: user?.email,
                lastName: lastName,
                phoneNumber: phone,
            }
            dispatch(updateUser(data));
        }
    }

    const handleContactUpdate = async () => {
        const newErrors = {};
        if (!email) {
            newErrors.email = 'Email is required';
        }

        if (!department) {
            newErrors.department = 'Please provide department';
        }

        if (!title) {
            newErrors.title = 'Please provide title';
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setDataLoading(true);
            const formData = new FormData();
            Array.from(logos).forEach((file, index) => {
                formData.append('logo_images', file); // The key 'files' should match what your backend expects
            });
            if (organization.logo_urls !== null) {
                formData.append('logo_urls', JSON.stringify(organization.logo_urls.map(item => ({
                    ...item,
                    sortUrl: item?.sortUrl?.split('&at=')[0]
                }))));
            }
            formData.append('org_name', organization?.org_name);
            formData.append('user_id', user?.user_id);
            formData.append('org_email', email);
            formData.append('org_phone_number', orgPhone !== null ? orgPhone : '');
            formData.append('org_website', orgWebsite !== null ? orgWebsite : '');
            formData.append('department', department);
            formData.append('title', title);
            try {
                if (organization.organization_id) {
                    const response = await apiRequest('put', `/organization/${organization.organization_id}`, formData);
                    if (response?.data) {
                        showNotification(response?.data?.message, 'success');
                        setLogos([]);
                        dispatch(orgUpdate(response.data));
                        setDataLoading(false);
                    }
                }
            } catch (error) {
                setDataLoading(false);
                showNotification(error?.response?.data.error || error.message, 'error');
            }
        }
    }

    const saveAddress = () => {
        const newErrors = {};
        if (!country) {
            newErrors.country = 'Please select a country';
        }

        if (!address1) {
            newErrors.address1 = 'Address1 is required';
        }

        if (!city) {
            newErrors.city = 'City is required';
        }

        if (!zipCode) {
            newErrors.zipcode = 'Zip Code is required';
        }

        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            const data = {
                userId: user?.user_id,
                organizationId: user?.organization?.organization_id,
                addressId: address?.address_id,
                country,
                address1,
                address2,
                city,
                state,
                zipCode
            }
            if (data.addressId) {
                dispatch(updateAddress(data));
            } else {
                dispatch(createAddress(data));
            }
        }
    }

    useEffect(() => {
        if (message) {
            showNotification(message, 'success');
            dispatch(defaultApiCall());
        }
        if (error) {
            showNotification(error, 'error');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [error, message]);

    useEffect(() => {
        if (orgMessage) {
            showNotification(orgMessage, 'success');
            dispatch(defaultOrgApiCall());
        }
        if (orgError) {
            showNotification(orgError, 'error');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orgError, orgMessage]);

    useEffect(() => {
        if (user?.organization?.organization_id) {
            setFirstName(user?.first_name);
            setLastName(user?.last_name);
            setEmail(user?.email);
            setPhone(user?.phone_number);
            setOrgPhone(user?.phone_number);
            dispatch(getOrganization({
                organizationId: user?.organization?.organization_id
            }));
            dispatch(getAddress({
                userId: user?.user_id,
                organizationId: user?.organization?.organization_id,
            }));
        }
    }, [user]);

    const handleFileUpload = (event) => {
        const files = event.target.files;
        if (files) {
            setLogos(files);
        }
    };

    return (
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            {(loading || orgLoading || dataLoading) ? (<LoadingPage isLoading={loading || orgLoading || dataLoading} />) : ''}
            <DividerHeader />
            <Box sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                <ArrowBackIosIcon color="primary" sx={{ cursor: 'pointer' }} onClick={() => navigate('/app/home/dashboard')} />
                <Typography variant='h4' style={{ fontWeight: 'bold' }}>My Profile - {user.first_name} {user.last_name ? user.last_name : ''} {isUser?.name ? `(${isUser?.name})` : ''}</Typography>
            </Box>
            <Divider />
            <DemoPaper>
                <Heading>Account Information</Heading>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">First Name <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="First Name"
                                id="standard-adornment-password"
                                type='text'
                                value={firstName || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.firstName = '';
                                    } else {
                                        newErrors.firstName = 'First Name is required'
                                    }
                                    setErrors(newErrors);
                                    setFirstName(e.target.value)
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.firstName}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Last Name</InputLabel>
                            <OutlinedInput
                                label="Last Name"
                                id="standard-adornment-password"
                                type='text'
                                value={lastName || ''}
                                onChange={(e) => {
                                    setLastName(e.target.value)
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">User Name</InputLabel>
                            <OutlinedInput
                                label="User Name"
                                id="standard-adornment-password"
                                type='text'
                                disabled
                                value={user.email || ''}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Phone Number</InputLabel>
                            <OutlinedInput
                                label="Phone Number"
                                id="standard-adornment-password"
                                type='number'
                                value={phone || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    setPhone(e.target.value)
                                    const phoneRegex = /^(?:\+?(\d{1,2}))?[-.\s]?(\(?\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;
                                    if (phoneRegex.test(e.target.value)) {
                                        newErrors.phoneNumber = '';
                                    } else if (!e.target.value) {
                                        newErrors.phoneNumber = '';
                                    } else {
                                        newErrors.phoneNumber = 'Please provide valid phone number';
                                    }
                                    setErrors(newErrors);
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.phoneNumber}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => handleAccountUpdate()}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </DemoPaper>
            <DemoPaper>
                <Heading>Contact Information</Heading>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Email <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="Email"
                                id="standard-adornment-password"
                                type='text'
                                value={email || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (!e.target.value) {
                                        newErrors.email = 'Email is required';
                                    } else if (!/\S+@\S+\.\S+/.test(e.target.value)) {
                                        newErrors.email = 'Email is invalid';
                                    } else {
                                        newErrors.email = '';
                                    }
                                    setErrors(newErrors);
                                    setEmail(e.target.value);
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.email}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Organization Phone Number</InputLabel>
                            <OutlinedInput
                                label="Organization Phone Number"
                                id="standard-adornment-password"
                                type='number'
                                value={orgPhone || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    setOrgPhone(e.target.value)
                                    const phoneRegex = /^(?:\+?(\d{1,2}))?[-.\s]?(\(?\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;
                                    if (phoneRegex.test(e.target.value)) {
                                        newErrors.orgPhone = '';
                                    } else if (!e.target.value) {
                                        newErrors.orgPhone = '';
                                    } else {
                                        newErrors.orgPhone = 'Please provide valid phone number';
                                    }
                                    setErrors(newErrors);
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.orgPhone}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Organization Name</InputLabel>
                            <OutlinedInput
                                label="Organization Name"
                                id="standard-adornment-password"
                                type='text'
                                value={organization?.org_name || ''}
                                disabled
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Organization Type</InputLabel>
                            <OutlinedInput
                                label="Organization Type"
                                id="standard-adornment-password"
                                type='text'
                                value={organization?.org_type?.charAt(0).toUpperCase() + organization?.org_type?.slice(1)}
                                disabled
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Organization Website</InputLabel>
                            <OutlinedInput
                                label="Organization Website"
                                id="standard-adornment-password"
                                type='text'
                                value={orgWebsite || ''}
                                onChange={(e) => {
                                    setOrgWebsite(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Department <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="Department"
                                id="standard-adornment-password"
                                type='text'
                                value={department || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.department = '';
                                    } else {
                                        newErrors.department = 'Please provide department';
                                    }
                                    setErrors(newErrors);
                                    setDepartment(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.department}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Title <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="Title"
                                id="standard-adornment-password"
                                type='text'
                                value={title || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.title = '';
                                    } else {
                                        newErrors.title = 'Please provide title';
                                    }
                                    setErrors(newErrors);
                                    setTitle(e.target.value);
                                }}
                            />
                        </FormControl>
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.title}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            <Tooltip title="upload logo">
                                <IconButton component="label" style={{ padding: 0, width: 40, height: 40, border: '1px solid black' }}>
                                    <CloudUploadIcon />
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(event) => handleFileUpload(event)}
                                        accept=".jpeg,.jpg,.png,.PNG"
                                        multiple
                                    />
                                </IconButton>
                            </Tooltip>
                            {Array.from(logos).length > 0 && Array.from(logos).map((a, index) => (
                                <Box style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px', border: '1px solid lightgray' }}>
                                    <Typography color='primary'>{a?.name}</Typography>
                                    <Tooltip title="remove logo">
                                        <ClearIcon
                                            style={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={async () => {
                                                const updatedList = [...logos];
                                                updatedList.splice(index, 1);
                                                setLogos(updatedList);
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            ))}

                            {organization.logo_urls?.length > 0 && organization.logo_urls.length <= 7 && organization.logo_urls.map((a) => (
                                <Box style={{ position: 'relative', padding: '7px 30px 0px 30px', border: '1px solid lightgray' }}>
                                    <img src={`${process.env.REACT_APP_IMAGEURL}bbn=${a?.sortUrl}&uid=${user?.user_id}`} alt='logo' style={{ width: '50px', height: '50px' }} />
                                    <Tooltip title="remove logo">
                                        <ClearIcon
                                            style={{
                                                position: 'absolute',
                                                right: 1,
                                                top: 1,
                                                fontSize: 20,
                                                cursor: 'pointer'
                                            }}
                                            onClick={async () => {
                                                setDataLoading(true);
                                                try {
                                                    if (organization.organization_id) {
                                                        const response = await apiRequest('delete', `/organization/organization-logo/${organization.organization_id}?sortUrl=${a?.sortUrl}`);
                                                        if (response?.data) {
                                                            showNotification(response?.data?.message, 'success');
                                                            dispatch(orgUpdate(response.data));
                                                            setDataLoading(false);
                                                        }
                                                    }
                                                } catch (error) {
                                                    setDataLoading(false);
                                                    showNotification(error?.response?.data.error || error.message, 'error');
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            {organization.logo_urls?.length > 0 && organization.logo_urls?.length >= 8 && organization.logo_urls.map((a) => (
                                <Box style={{ position: 'relative', padding: '7px 30px 0px 30px', border: '1px solid lightgray' }}>
                                    <img src={`${process.env.REACT_APP_IMAGEURL}bbn=${a?.sortUrl}&uid=${user?.user_id}`} alt='logo' style={{ width: '50px', height: '50px' }} />
                                    <Tooltip title="remove logo">
                                        <ClearIcon
                                            style={{
                                                position: 'absolute',
                                                right: 1,
                                                top: 1,
                                                fontSize: 20,
                                                cursor: 'pointer'
                                            }}
                                            onClick={async () => {
                                                setDataLoading(true);
                                                try {
                                                    if (organization.organization_id) {
                                                        const response = await apiRequest('delete', `/organization/organization-logo/${organization.organization_id}?sortUrl=${a?.sortUrl}`);
                                                        if (response?.data) {
                                                            showNotification(response?.data?.message, 'success');
                                                            dispatch(orgUpdate(response.data));
                                                            setDataLoading(false);
                                                        }
                                                    }
                                                } catch (error) {
                                                    setDataLoading(false);
                                                    showNotification(error?.response?.data.error || error.message, 'error');
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            ))}
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => handleContactUpdate()}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </DemoPaper>
            <DemoPaper>
                <Heading>Address Information</Heading>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Address 1 <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="Address 1"
                                id="standard-adornment-password"
                                type='text'
                                value={address1 || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.address1 = ''
                                    } else {
                                        newErrors.address1 = 'Address1 is required'
                                    }
                                    setErrors(newErrors);
                                    setAddress1(e.target.value);
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.address1}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Address 2</InputLabel>
                            <OutlinedInput
                                label="Address 2"
                                id="standard-adornment-password"
                                type='text'
                                value={address2 || ''}
                                onChange={(e) => {
                                    setAddress2(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">City <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="City"
                                id="standard-adornment-password"
                                type='text'
                                value={city || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.city = ''
                                    } else {
                                        newErrors.city = 'City is required'
                                    }
                                    setErrors(newErrors);
                                    setCity(e.target.value);
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.city}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">State</InputLabel>
                            <OutlinedInput
                                label="State"
                                id="standard-adornment-password"
                                type='text'
                                value={state || ''}
                                onChange={(e) => {
                                    setState(e.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={12} md={6}>
                        <Autocomplete
                            value={countries.find((c) => c.code === country?.toUpperCase()) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={countries}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                const newErrors = errors;
                                if (newValue?.code) {
                                    newErrors.country = ''
                                } else {
                                    newErrors.country = 'Please select a country'
                                }
                                setErrors(newErrors);
                                setCountry(newValue?.code);
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label={<span>Country <span style={{ color: 'red' }}>*</span></span>} name="Country" variant="outlined" />}
                        />
                        <Typography variant='body2' style={{ color: 'red' }}>{errors.country}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Zip Code <span style={{ color: 'red' }}>*</span></InputLabel>
                            <OutlinedInput
                                label="Zip Code"
                                id="standard-adornment-password"
                                type='number'
                                value={zipCode || ''}
                                onChange={(e) => {
                                    const newErrors = errors;
                                    if (e.target.value) {
                                        newErrors.zipcode = ''
                                    } else {
                                        newErrors.zipcode = 'Zip Code is required'
                                    }
                                    setErrors(newErrors);
                                    setZipCode(e.target.value);
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                            <Typography variant='body2' style={{ color: 'red' }}>{errors.zipcode}</Typography>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ justifyContent: 'flex-end', display: 'flex' }}>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={() => saveAddress()}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </DemoPaper>
        </Box>
    )
}